import { render, staticRenderFns } from "./OrdersInNominative.vue?vue&type=template&id=41a69f70&scoped=true"
import script from "./OrdersInNominative.vue?vue&type=script&lang=js"
export * from "./OrdersInNominative.vue?vue&type=script&lang=js"
import style0 from "./OrdersInNominative.vue?vue&type=style&index=0&id=41a69f70&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41a69f70",
  null
  
)

export default component.exports